import { z } from 'zod';
import { deletedFilterFields, refineDeletedFilterMutualExclusion } from './common.js';
// Mirror the inline NestBlock schema in apps/api/src/routes/admin.ts
// (ctsk-055) so both bundle-import and direct CRUD enforce the same
// shape — kebab slug, ≤4 char uppercase code, name + optional
// description.
/**
 * Strict (CTSK-445) — unknown keys are rejected with 400
 * VALIDATION_ERROR naming the offending key, instead of Zod's default
 * silent strip. Class-fix for the CTSK-427 silent-drop bug (memory
 * feedback_zod_field_name_silent_drop).
 */
export const NestCreateSchema = z.object({
    slug: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z0-9][a-z0-9-]*$/, 'slug must be kebab-case (lower-case letters, digits, dashes; cannot start with -)'),
    code: z
        .string()
        .min(1)
        .max(4)
        .regex(/^[A-Z0-9]+$/, 'code must be 1-4 uppercase letters/digits'),
    name: z.string().min(1).max(120),
    description: z.string().max(500).nullable().optional(),
}).strict();
// .strip() restores Zod's default unknown-key tolerance for PATCH —
// CTSK-445 made Create strict, and .partial() would otherwise inherit
// `unknownKeys: "strict"`. Patch semantics deliberately unchanged.
export const NestPatchSchema = NestCreateSchema.partial().strip();
// CTSK-388 (Phase 2 of CTSK-385) — first list-query schema for nests.
// `GET /nests` previously read no query params at all and returned
// soft-deleted rows unconditionally; this closes that gap.
export const NestsListQuerySchema = z
    .object({
    ...deletedFilterFields,
})
    .superRefine(refineDeletedFilterMutualExclusion);
//# sourceMappingURL=nest.js.map